import { EHeadingStyleVariant, Heading } from '@outdoorsyco/bonfire';
import cn from 'classnames';
import React from 'react';

import { AnimatedHeadline } from './AnimatedHeadline';

type THeadlineProps = {
  value: Array<string | string[]>;
};

export const Headline = ({ value }: THeadlineProps) => {
  return (
    <>
      <Heading
        component="div"
        variant={EHeadingStyleVariant.H1Alt}
        className={cn(
          'flex flex-col not-italic font-normal break-words lg:mb-8 lg:mt-2 text-[32px] md:text-[72px] leading-10 md:leading-none md:mt-2 mb-4',
        )}>
        {value.map((v, index) => {
          if (typeof v === 'string' || v.length === 1) {
            return <span key={index}>{Array.isArray(v) ? v[0] : v}</span>;
          }

          return v.length > 1 ? <AnimatedHeadline key={index} value={v} /> : null;
        })}
      </Heading>
    </>
  );
};
